'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index = require('../../../../../../../node_modules/@radix-ui/react-dropdown-menu/dist/index.cjs');
var Content_web_styles = require('./Content.web.styles.cjs');

/**
 * Sub component of DropdownMenu that holds the content to be displayed
 */ const Content = ({ side = "bottom", align = "start", children })=>{
    return /*#__PURE__*/ jsxRuntime.jsx(index.Portal, {
        children: /*#__PURE__*/ jsxRuntime.jsx(index.Content, {
            className: "DropdownMenuContent",
            side: side,
            align: align,
            css: Content_web_styles.content,
            sideOffset: 5,
            children: children
        })
    });
};
Content.displayName = "DropdownMenu.Content";

exports.Content = Content;
//# sourceMappingURL=Content.web.cjs.map
